import { AutoComplete, Button, Col, Divider, Form, Input, Row, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../../context/AuthProvider';
import {
  updateField,
  updatePmOfferProjectInterval,
} from '../../../../../contextRedux/PMOfferProject/PmOfferModelProject';
import { RootState } from '../../../../../store';

const ProjectCompanyDetailsTab: React.FC<any> = ({ form }) => {
  const dispatch = useDispatch();
  //initialize from pmOffer
  const id = useSelector((state: RootState) => state?.models?.pmOfferProject?.id);
  const companyId = useSelector((state: RootState) => state?.models?.pmOfferProject?.companyId);

  //initialize from parrent NewOffer
  const companies = useSelector((state: RootState) => state.store.company.data);
  const pmOfferStatuses = useSelector((state: RootState) => state?.store.pmOfferStatus.data);
  const pmOfferContractTypes = useSelector((state: RootState) => state?.store.pmOfferContractType.data);
  const users = useSelector((state: RootState) => state?.store.user.data);
  const pmOffer = useSelector((state: RootState) => state?.models.pmOffer);

  const [currentTotal, setCurrentTotal] = useState(0);
  const currentDate = moment().format('YYYY-MM-DD');
  const { profile } = useAuth();

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.pmOfferProject?.company),
    companyId: useSelector((state: RootState) => state?.models?.pmOfferProject?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.pmOfferProject?.accountManager),
    projectAuthor: useSelector((state: RootState) => state?.models?.pmOfferProject?.projectAuthor),
    projectAuthorId: useSelector((state: RootState) => state?.models?.pmOfferProject?.projectAuthorId),
    chiefTechnicianId: useSelector((state: RootState) => state?.models?.pmContractProject?.chiefTechnicianId),
    enumPmOfferContractTypeId: useSelector(
      (state: RootState) => state?.models?.pmOfferProject?.enumPmOfferContractTypeId
    ),
    enumPmOfferContractType: useSelector((state: RootState) => state?.models?.pmOfferProject?.enumPmOfferContractType),
    enumPmOfferStatusId: useSelector((state: RootState) => state?.models?.pmOfferProject?.enumPmOfferStatusId),
    enumPmOfferStatus: useSelector((state: RootState) => state?.models?.pmOfferProject?.enumPmOfferStatus),
    date: useSelector((state: RootState) => state?.models?.pmOfferProject?.date),
    dateStart: useSelector((state: RootState) => state?.models?.pmOfferProject?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.pmOfferProject?.dateEnd),
    remarks: useSelector((state: RootState) => state?.models?.pmOfferProject?.remarks),
    pmOfferIntervals: useSelector((state: RootState) => state?.models?.pmOfferProject?.pmOfferIntervals),
    totalOfferValue:
      Number.parseFloat(
        (
          pmOffer.pmOfferWorkPlaceItems.reduce((total: any, item: any) => total + item.laborPrice, 0) +
          (pmOffer.pmOfferLaborExtras
            ? pmOffer.pmOfferLaborExtras.reduce((total: any, item: any) => total + item?.piece * item?.price, 0)
            : 0)
        ).toFixed(2)
      ) +
      Number.parseFloat(
        pmOffer.pmOfferWorkPlaceItems.reduce((total: any, item: any) => {
          const totalPrice = item.price;
          return total + totalPrice;
        }, 0)
      ),
  };

  const handleFieldChange = (changedValues: any, allValues: any) => {
    for (const key in changedValues) {
      if (key === 'pmOfferIntervals') {
        // Recalculate total
        calculateTotal(allValues['pmOfferIntervals']);
        // Update the entire intervals array in Redux state
        dispatch(updateField({ field: 'pmOfferIntervals', value: allValues['pmOfferIntervals'] }));
      } else {
        dispatch(updateField({ field: key, value: changedValues[key] }));
      }
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: company?.name,
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);

    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));

    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectProjectAuthor = (value: string) => {
    const projectAuthor = users?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      projectAuthor: projectAuthor,
      projectAuthorId: projectAuthor?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'projectAuthorId', value: projectAuthor?.id ?? null }));
    dispatch(updateField({ field: 'projectAuthor', value: projectAuthor ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = pmOfferStatuses.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmOfferStatusId: selectStatus?.id,
      enumPmOfferStatus: selectStatus,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmOfferStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumPmOfferStatus', value: selectStatus ?? null }));
  };

  const handleSelectType = (_value: string) => {
    const selectedType = pmOfferContractTypes.filter((pc) => [2].includes(pc.id)).find((type: any) => type.id === 2);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmOfferContractTypeId: selectedType?.id,
      enumPmOfferContractType: selectedType,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: selectedType?.id ?? null }));
    dispatch(updateField({ field: 'enumPmOfferContractType', value: selectedType ?? null }));
  };

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  // Access interval price based on the current index
  const getCurrentIntervalPrice = () => {
    const total = form
      .getFieldValue('pmOfferIntervals')
      ?.reduce((acc: number, cur: any) => acc + Number(cur?.price ?? 0), 0);
    return total ?? 0;
  };

  const handleRemove = (remove: Function, name: number) => {
    remove(name);
    const intervals = [...(form.getFieldValue('pmOfferIntervals') || [])];
    intervals.splice(name, 1); // Remove the interval from the array
    calculateTotal(intervals);
  };

  const calculateTotal = (intervals: any[]) => {
    const total = (intervals || []).reduce((sum, interval) => sum + Number(interval?.price || 0), 0);
    setCurrentTotal(total);
  };

  const handleAddInterval = (add: Function) => {
    add();
  };

  useEffect(() => {
    form.setFieldValue('pmOfferIntervals', pmOffer.pmOfferIntervals);
  }, []);

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: { name: company?.name },
        companyId: company?.id,
        accountManager: company?.accountManager,
      });
      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });
      if (id == null || id == undefined || id == '') {
        handleSelectProjectAuthor(profile?.name!);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (id == null || id == undefined || id == '') {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      form.setFieldsValue({
        enumPmOfferStatusId: 1,
        enumPmOfferContractTypeId: 1,
        date: currentDate,
        dateStart: currentDate,
        dateEnd: formattedOneYearLater,
      });

      dispatch(updateField({ field: 'enumPmOfferStatusId', value: 1 }));
      dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: 2 }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
    }
  }, [id]);

  const isLastStatusSelected =
    pmOfferStatuses && pmOffer.enumPmOfferStatus?.name === pmOfferStatuses[pmOfferStatuses.length - 1]?.name;
  const remainingValue = initialValues.totalOfferValue - currentTotal;

  return (
    <Form
      form={form}
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      layout='vertical'
      style={{ margin: '20px 20px' }}
    >
      <Row gutter={[10, 10]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch // Enables search functionality
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={(_value, option: any) => {
                handleSelectClient(option);
              }}
              onChange={() => handleBlurClear(['company', 'companyId'])} // Clear form fields when changed
              filterOption={(input, option) => {
                return option?.label?.toLowerCase()?.includes(input.toLowerCase());
              }}
              options={companies?.map((company: any) => ({
                value: company?.id,
                label: company?.name,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['projectAuthor', 'name']}
            label='Autor proiect'
            rules={[{ required: true, message: 'Alegeti un autor de proiect!' }]}
          >
            <AutoComplete
              options={users?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectProjectAuthor}
              onChange={() => handleBlurClear(['projectAuthor', 'projectAuthorId'])}
              filterOption={(input, option: any) => option.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmOfferStatus', 'name']}
            label='Status'
            rules={[{ required: true, message: 'Alegeti un status!' }]}
          >
            <AutoComplete
              options={pmOfferStatuses?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumPmOfferStatus', 'enumPmOfferStatusId'])}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmOfferContractType', 'name']}
            label='Tip oferta'
            rules={[{ required: true, message: 'Alegeti un tip oferta!' }]}
          >
            <AutoComplete
              options={pmOfferContractTypes
                ?.filter((pc) => [2].includes(pc.id))
                ?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectType}
              onChange={() => handleBlurClear(['enumPmOfferContractType', 'enumPmOfferContractTypeId'])}
            />
          </Form.Item>
        </Col>
        <Divider />
      </Row>

      <Row gutter={[16, 1]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item label='Data Oferta' name='date' rules={[{ required: true, message: 'Introduceti data oferta!' }]}>
            <Input type='date' onChange={(e) => onDateChange('date', e.target.value)} min={currentDate} />
          </Form.Item>
        </Col>
        {isLastStatusSelected && (
          <>
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                label='Data Incepere Proiect'
                name='dateStart'
                rules={[
                  {
                    required: true,
                    message: 'Introduceti data incepere proiect!',
                  },
                ]}
              >
                <Input type='date' onChange={(e) => onDateChange('dateStart', e.target.value)} min={currentDate} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                label='Data Sfarsit Proiect'
                name='dateEnd'
                rules={[
                  {
                    required: true,
                    message: 'Introduceti data sfarsit proiect!',
                  },
                ]}
              >
                <Input type='date' onChange={(e) => onDateChange('dateEnd', e.target.value)} min={currentDate} />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      <Divider />
      <Form.List name='pmOfferIntervals'>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <Row key={key} gutter={16} align='middle'>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    label='Data'
                    name={[name, 'date']}
                    rules={[{ required: true, message: 'Introduceti data!' }]}
                  >
                    <Input
                      type='date'
                      onChange={(e) => {
                        const dateValue = e.target.value;
                        dispatch(updatePmOfferProjectInterval({ index, updates: { date: dateValue } }));
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    label='Valoare'
                    name={[name, 'price']}
                    rules={[
                      { required: true, message: 'Introduceti pretul!' },
                      () => ({
                        validator(_, _value) {
                          const currentPrice = getCurrentIntervalPrice();
                          if (currentPrice <= initialValues.totalOfferValue) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(`Valoarea totală nu poate depăși ${initialValues.totalOfferValue}`)
                          );
                        },
                      }),
                    ]}
                  >
                    <Input
                      type='number'
                      min={0}
                      max={remainingValue + Number(getCurrentIntervalPrice())}
                      onChange={(e) => {
                        const priceValue = Number(e.target.value);
                        dispatch(updatePmOfferProjectInterval({ index, updates: { price: priceValue } }));
                        const intervals = form.getFieldValue('pmOfferIntervals') || [];
                        calculateTotal(intervals);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Button onClick={() => handleRemove(remove, name)}>Sterge</Button>
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button
                type='dashed'
                onClick={() => handleAddInterval(add)}
                block
                disabled={!(getCurrentIntervalPrice() <= initialValues.totalOfferValue)}
              >
                Adauga Incasare
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default ProjectCompanyDetailsTab;
